module.exports = __webpack_public_path__ + "static/media/17.4d0c761f.jpg";